import { DKVMobilityLogo } from "@App/Components/atoms/whitelabel/logos/DKVMobilityLogo";
import { RepareoLogo } from "@App/Components/atoms/whitelabel/logos/RepareoLogo";
import type { Config } from "@App/configs/interfaces";

/**
 * Configuration for the DKV Mobility whitelabel.
 * Extends the default configuration with specific settings for DKV Mobility.
 */
export const config: Partial<Config> = {
  slug: "dkv-mobility",
  navbar: {
    logos: {
      // Arrangement agreed with DKV so repareo reads as the operator: repareo first, and the gap on
      // either side of the separator is half the (40px) logo height.
      left: {
        component: (
          <div className={"flex items-center gap-5"}>
            <RepareoLogo />
            <hr aria-orientation="vertical" className={"h-10 w-px m-0 border-0 bg-neutral-300"} />
            <DKVMobilityLogo />
          </div>
        ),
      },
    },
    backToPartnerButton: {
      url: "https://www.dkv-mobility.com/de/de",
    },
  },
  reviews: {
    show: true,
  },
};

export default config;
